export default "__VITE_ASSET__bPzOZ$dd__"